import { render, staticRenderFns } from "./ChannelFeeListSidebar.vue?vue&type=template&id=5eb9b146&"
import script from "./ChannelFeeListSidebar.vue?vue&type=script&lang=js&"
export * from "./ChannelFeeListSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ChannelFeeListSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports